<script setup lang="ts">
  import { computed, useId } from 'vue';
  import { Attribute } from '../Attribute';
  import { Badge } from '../Badge';
  import { BadgeColor, BadgeVariant } from '../Badge/Badge.types';
  import { rootClass, statValueClass } from './StatItem.css';
  import type { StatItemProps } from './StatItem.types';

  const props = withDefaults(defineProps<StatItemProps>(), {
    color: BadgeColor.INFO,
  });

  defineSlots<{
    value?: () => unknown;
  }>();

  const uid = useId();
  const resolvedTestId = computed(() => props.testId ?? `ds-stat-item-${uid}`);
</script>

<template>
  <div :class="rootClass" :data-testid="resolvedTestId">
    <Badge
      v-if="iconName"
      :variant="BadgeVariant.ICON_ONLY"
      :color="color"
      :icon-name="iconName"
      :test-id="`${resolvedTestId}-badge`"
    />
    <Attribute :label="label">
      <span :class="statValueClass">
        <slot name="value">{{ value || '-' }}</slot>
      </span>
    </Attribute>
  </div>
</template>
